import axios from 'axios';

import {url} from 'utils/urls';

const withCredentials = true;
const headers = {
    "Content-Type": "application/json"
};
const imageHeaders = {
    'Content-Type': 'multipart/form-data'
};

export const asyncRequestCommentingWidget = (accountUUID) => axios.post(`${url.ppa.url}/v1/accounts/${accountUUID}/product-access-requests`, { 'productType': 'COMMENTING' }, { withCredentials });

export const asyncGetCommentingData = (accountUUID) => axios.get(`${url.ppa.url}/v1/accounts/${accountUUID}/product-access-requests?productType=COMMENTING`, { withCredentials });

export const asyncHasCommentingUnit = (siteUUID) => axios.get(`${url.ppa.url}/v1/sites/${siteUUID}/commenting`, { withCredentials });

export const asyncCreateCommentingUnit = (unitData) => axios.post(`${url.ppa.url}/v1/sites/commenting`, unitData, { withCredentials });

export const asyncApproveCommenting = (accountUUID) => axios.post(`${url.ppa.url}/v1/accounts/${accountUUID}/product-access-requests`, { 'productType': 'COMMENTING' }, { withCredentials });

// config
export const asyncGetConfigSettings = (accountUUID, siteUUID, siteURL) => axios.get(`${url.ccu.base}/v1/sites/${siteUUID}/configurations?accountUUID=${accountUUID}&siteURL=${siteURL}`, { headers, withCredentials });

export const asyncUpdateColorConfiguration = (colorConfigurationUUID, colorScheme) => axios.put(`${url.ccu.base}/v1/commenting-units/configurations/color-schemes/${colorConfigurationUUID}`, colorScheme, { headers, withCredentials });

export const asyncUpdateAvatarPack = (commentingUnitConfigurationUUID, avatarData) => axios.put(`${url.ccu.base}/v1/commenting-units/configurations/${commentingUnitConfigurationUUID}/avatar-packs`, avatarData, { headers, withCredentials });

export const asyncGetStatisticsTableData = (commentingUnitUUID, interval, skip) => axios.get(`${url.ccu.base}/v1/commenting-units/${commentingUnitUUID}/metrics/commenting-units?interval=${interval}&skip=${skip}`, { headers, withCredentials });

export const asyncExportStatisticsData = (commentingUnitUUID, interval) => axios.get(`${url.ccu.base}/v1/commenting-units/${commentingUnitUUID}/metrics/commenting-units/export?interval=${interval}`, { headers, withCredentials });

export const asyncGetCommentingUnitCode = (siteUUID) => axios.get(`${url.ccu.base}/v1/sites/${siteUUID}/commenting-units/code`, { headers, withCredentials });

export const asyncUpdateModeration = (moderationUUID, moderationData) => axios.put(`${url.ccu.base}/v1/commenting-units/configurations/moderations/${moderationUUID}`, moderationData, { withCredentials });

export const asyncUpdateCommentsTree = (commentTreeConfigurationUUID, commentsTreeData) => axios.put(`${url.ccu.base}/v1/commenting-units/configurations/comments-tree/${commentTreeConfigurationUUID}`, commentsTreeData, { headers, withCredentials });

export const asyncUpdateCommunity = (communityConfigurationUUID, communityData) => axios.put(`${url.ccu.base}/v1/commenting-units/configurations/community/${communityConfigurationUUID}`, communityData, { headers, withCredentials });

export const asyncUploadImage = (uploadImage) => axios.post(`${url.ccu.base}/v1/commenting-units/images`, uploadImage, { imageHeaders, withCredentials });

export const asyncUpdateGeneral = (configUUID, generalData) => axios.put(`${url.ccu.base}/v1/commenting-units/configurations/${configUUID}/generals`, generalData, { withCredentials });

export const asyncGetExportData = (commentingUnitUUID, format) => axios.get(`${url.ccu.base}/v1/commenting-units/${commentingUnitUUID}/metrics/user-profiles/export?format=${format}`, { headers, withCredentials });

export const asyncGetCommentingEmailIfExist = (email) => axios.get(`${url.ppa.url}/v1/commenting/email/${email}`, { withCredentials });